import { ButtonPrimary, ButtonSize } from '@ui/src';
import Card from '../card/card';
import TopUpOptionItem from './overview-topup-item';
import { TopUpOptionsTypes } from './types';

import cn from './overview-topup.module.css';

const TopUpOptions = ({
  topUpOptions,
  isLoading,
  customerType,
  organizationId,
  setSelectedTopUpId,
  setTopUpPanelIsOpen,
  topUpOptionsPagination,
  getNextTopUpOptions,
  topUpOptionsIsLoading,
  status,
  topUpVisibilityIsLoading,
  topUpVisibility,
}: TopUpOptionsTypes): React.JSX.Element => (
  <>
    <Card
      isLoading={isLoading}
      title="Top-up options"
      className={
        topUpOptionsPagination?.hasNextPage ? cn.topUpCardSmallMargin : ''
      }
    >
      {topUpOptions?.map((item) => (
        <TopUpOptionItem
          key={item.id}
          topUpOption={item}
          customerType={customerType}
          setTopUpPanelIsOpen={setTopUpPanelIsOpen}
          setSelectedTopUpId={setSelectedTopUpId}
          organizationId={organizationId}
          status={status}
          visibility={topUpVisibility?.find(
            (visibility) => visibility.pspPartnerId === item.id,
          )}
          topUpVisibilityIsLoading={topUpVisibilityIsLoading}
        />
      ))}
    </Card>
    {topUpOptionsPagination?.hasNextPage && (
      <ButtonPrimary
        text={topUpOptionsIsLoading ? 'Loading...' : 'Show more'}
        className={cn.showMoreTopUpButton}
        size={ButtonSize.SMALL}
        onClick={() => getNextTopUpOptions(topUpOptionsPagination.endCursor)}
        bold
      />
    )}
  </>
);

export default TopUpOptions;
